<template>
    <div>
        <div class="container">
            <!-- 打印导出 -->
            <el-dialog title="打印出库单" :visible.sync="printerDialogVisible" width="50%" :close-on-click-modal="false">
                <!-- 用运单号，出库单号搜索得到列表内容 增加一个出库单号二维码 -->
                <div v-print="'#printDiv'" id="print-content">
                    <div class="print-title">
                        <span style="width: 85%;text-align: center;">销售出库单</span>
                        <div ref="qrcode"></div>
                    </div>
                    <el-form ref="printerForm" :model="printerForm" label-width="80px">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="单据日期" prop="data">
                                    <el-date-picker style="width:100%" v-model="printerForm.create_time" type="date"
                                        value-format="yyyy-MM-dd" placeholder="请选择单据日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="单据编号" prop="freight_bill_code">
                                    <el-input v-model.trim="printerForm.freight_bill_code" style="width:100%" clearable
                                        placeholder="请输入单据编号" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="发货仓库" prop="from_warehouse_code">
                                    <el-select v-model.trim="printerForm.from_warehouse_code" placeholder="请选择"
                                        style="width: 100%" filterable value-key="warehouseUuid">
                                        <el-option v-for="item in fromWarehouse" :key="item.warehouseUuid"
                                            :label="item.warehouseName" :value="item.warehouseCode" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="客户" prop="dealer_name">
                                    <el-input v-model.trim="printerForm.dealer_name" style="width:100%" clearable
                                        placeholder="请输入客户" />
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="8">
                                <el-form-item label="部门" prop="department">
                                    <el-input v-model.trim="printerForm.department" style="width:100%" clearable
                                        placeholder="请输入部门" />
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="8">
                                <el-form-item label="经手人" prop="handlePerson">
                                    <el-input v-model.trim="printerForm.handlePerson" style="width:100%" clearable
                                        placeholder="请输入经手人" />
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="8">
                                <el-form-item label="来源单据" prop="voucher">
                                    <el-input v-model.trim="printerForm.voucher" style="width:100%" clearable
                                        placeholder="请输入来源单据" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="来源单号" prop="out_bill_code">
                                    <el-input v-model.trim="printerForm.out_bill_code" style="width:100%" clearable
                                        placeholder="请输入来源单号" />
                                </el-form-item>
                            </el-col> -->
                            <!-- <el-col :span="8">
                                <el-form-item label="包邮" prop="postage">
                                    <el-select v-model="printerForm.postage" placeholder="请选择" style="width:100%"
                                        clearable>
                                        <el-option v-for="item in postageList" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="15">
                                <el-form-item label="备注" prop="extension_field2">
                                    <el-input v-model.trim="printerForm.extension_field2" style="width:100%" clearable
                                        placeholder="请输入备注" />
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="8">
                                <el-form-item label="是否快递" prop="expressage">
                                    <el-select v-model="printerForm.expressage" placeholder="请选择" style="width:100%"
                                        clearable>
                                        <el-option v-for="item in expressageList" :key="item.value" :label="item.label"
                                            :value="item.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col> -->
                            <el-col style="margin: 5px 0 10px 0;" :span="24">
                                <el-table show-summary :summary-method="getSummaries" border
                                    :highlight-current-row='true' :data="tableData" style="width:100%;">
                                    <el-table-column type="index" label="序号" min-width="60" show-overflow-tooltip />
                                    <el-table-column prop="product_code" label="存货编码" min-width="100"
                                        show-overflow-tooltip />
                                    <el-table-column prop="product_name" label="存货名称" min-width="220"
                                        show-overflow-tooltip />
                                    <el-table-column prop="from_warehouse_code" label="商品形态" min-width="100"
                                        show-overflow-tooltip>
                                        <template>实物</template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="from_warehouse" label="赠品" min-width="80"
                                        show-overflow-tooltip>
                                        <template>否</template>
                                    </el-table-column> -->
                                    <el-table-column prop="unit_name" label="单位" min-width="80" show-overflow-tooltip />
                                    <el-table-column prop="plan_quantity" label="数量" min-width="80"
                                        show-overflow-tooltip />
                                </el-table>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="制单人" prop="data1">
                                    <el-input v-model.trim="printerForm.data1" style="width:100%" clearable
                                        placeholder="请输入制单人" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="审核人" prop="data2">
                                    <el-input v-model.trim="printerForm.data2" style="width:100%" clearable
                                        placeholder="请输入审核人" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="打印人" prop="data3">
                                    <el-input v-model.trim="printerForm.data3" style="width:100%" clearable
                                        placeholder="请输入打印人" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="打印日期" prop="today">
                                    <el-date-picker style="width:100%" v-model="printerForm.today" type="date"
                                        value-format="yyyy-MM-dd" placeholder="请选择单据日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="白联" prop="data4">
                                    <el-input v-model.trim="printerForm.data4" style="width:100%" clearable
                                        placeholder="请输入白联" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="红联" prop="data5">
                                    <el-input v-model.trim="printerForm.data5" style="width:100%" clearable
                                        placeholder="请输入红联" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="黄联" prop="data6">
                                    <el-input v-model.trim="printerForm.data6" style="width:100%" clearable
                                        placeholder="请输入黄联" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <!-- <div class="test3">黑体测试测试测试测试测试测试测试测试测试测试测试测试</div> -->
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="printerDialogVisibleCancel()">取 消</el-button>
                    <el-button type="primary" @click="submitPrinter()">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import QRCode from "qrcodejs2";
import printJS from 'print-js'
import { findwarehouse } from "@/api/query";
import { selectoutbillorder } from "@/api/physical";
import { defaultElementTypeProvider, hiPrintPlugin, hiprint } from 'vue-plugin-hiprint'
//引入导出组件模块
export default {
    name: "print",
    mounted() {
        this.getfromWarehouse()
        this.init()
    },
    data() {
        return {
            tableData: [],
            fromWarehouse: [],
            printerDialogVisible: false,
            printerForm: {
                createTime: '',
                voucher: '销货单',
                today: this.getTodayDate(),
                data4: '库房',
                data5: '财务室',
                data6: '结算客户',
            },
            postageList: [{ label: '不包邮', value: 0 }, { label: '包邮', value: 1 }],
            expressageList: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
            hiprintTemplate: null,
        };
    },
    methods: {
        init() {
            const hiprintTemplate_ = new this.$pluginName.PrintTemplate()
            this.hiprintTemplate = hiprintTemplate_
            console.log(this.hiprintTemplate, 'hiprintTemplate222');
        },
        confirmPrintPrint() {
            // 如果在 main.js 中设置了取消自动连接客户端 是获取不到打印机列表的！！！
            if (window.hiwebSocket.opened === false) {
                this.$notify.error('打印机客户端未连接，请点击右上角头像下载打印客户端')
            }

            // 这一句代码 如果打印出来有问题 可以尝试加进去，没有出现 则不用加
            // 初始化 provider
            this.$pluginName.init({
                providers: [defaultElementTypeProvider()]
            })

            // 这一句代码 如果打印出来有问题 可以尝试加进去，没有出现 则不用加
            this.$pluginName.PrintElementTypeManager.buildByHtml(this.$('.ep-draggable-item'))

            // 不要使用 this.hiprintTemplate 打印，会出现重复打印，如果要用，请每次打印 都清空内容
            const hiprintTemplate_ = new this.$pluginName.PrintTemplate()
            const panel = hiprintTemplate_.addPrintPanel({
                'height': 9,
                'width': 20,
                'paperHeader': 0,
                'paperFooter': 30,
                'paperNumberLeft': 26,
                'paperNumberTop': 6,
                'paperNumberDisabled': true,
                'orient': 1,
                'scale': 1
            })
            // 这一块代码是可以 放在 create 页面创建完成后 
            // 打印html内容
            panel.addPrintHtml({ options: { width: 20, height: 9, top: 0, left: 0, content: this.$('#printDiv').html() } })

            // 预览打印
            hiprintTemplate_.print()

            //  打印机列表
            const printerList = hiprintTemplate_.getPrinterList()
            console.info('打印机列表', printerList)

            // 直接打印 - 不带参数
            hiprintTemplate_.print2()

            // 直接打印 带参数
            hiprintTemplate_.print2(null, {
                printer: null, // 指定打印机 打印机 名称
                title: '打印任务名称',
                color: false, // 是否打印颜色 默认 true
                copies: 1, // 打印份数 默认 1
            });
        },
        getData(row) {
            this.printerForm = {
                ...row,
                createTime: '',
                voucher: '销货单',
                today: this.getTodayDate(),
                data4: '库房',
                data5: '财务室',
                data6: '结算客户',
            }
            setTimeout(() => {
                this.$refs.qrcode.innerHTML = ''
                this.qrcode(70, 70, row.out_bill_code, 'canvas')
            }, 300)
            const params = {
                out_bill_code: row.out_bill_code,
                freight_bill_code: row.freight_bill_code
            }
            selectoutbillorder(params).then(response => {
                const list = response.data.list

                let map = new Map();
                list.forEach(item => {
                    if (map.has(item.product_code)) {
                        let existingItem = map.get(item.product_code);
                        existingItem.plan_quantity = Number(existingItem.plan_quantity)
                        existingItem.plan_quantity += Number(item.plan_quantity);
                    } else {
                        map.set(item.product_code, { ...item });
                    }
                });

                let result = Array.from(map.values());

                this.tableData = result;
            });
            this.printerDialogVisible = true
        },
        initialize() {
            this.printerForm = {
                createTime: '',
                voucher: '销货单',
                today: this.getTodayDate(),
                data4: '库房',
                data5: '财务室',
                data6: '结算客户',
            }
        },
        printerDialogVisibleCancel() {
            this.initialize()
            this.printerDialogVisible = false
        },
        submitPrinter() {
            // this.confirmPrintPrint()
            // return
            // 调用 printHtml 方法触发打印操作
            printJS({
                printable: 'print-content',//打印区域id
                type: 'html',//打印类型
                style: `@page {margin:0 10mm}`,
                maxWidth: 920,
                targetStyles: ['*'],
                repeatTableHeader: false,
            })
        },
        getTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getfromWarehouse(value = null) {
            findwarehouse({ warehouseCode: value }).then((response) => {
                this.fromWarehouse = response.data.map((item => {
                    return {
                        ...item,
                        warehouseName: `${item.warehouseCode}|${item.warehouseName}`
                    }
                }))
            });
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (index === 6) {
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = ' ';
                    }
                }
            });
            return sums;
        },
        qrcode(qWidth, qHeight, qText, qRender) {
            let el = this.$refs.qrcode
            new QRCode(el, {
                width: qWidth,
                height: qHeight,
                text: qText,
                render: qRender
            })
        },
    }
};
</script>
<style lang="scss" scoped>
.print-title {
    display: flex;
    align-items: center;
    width: 100%;
    font-weight: 600;
    font-size: 27px;
    margin-bottom: 5px;
}



@font-face {
    font-family: 'title3';
    src: url('~@/assets/black.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

#print-content {
    color: black;
    font-family: '黑体', '微软雅黑', '宋体', serif;

    & ::v-deep .el-form-item__label {
        color: black;
        font-family: '黑体', '微软雅黑', '宋体', serif;
    }

    & ::v-deep .el-table__row {
        color: black;
        font-family: '黑体', '微软雅黑', '宋体', serif;
    }

    & ::v-deep .el-input__inner {
        color: black;
        font-family: '黑体', '微软雅黑', '宋体', serif;
    }

    & ::v-deep .cell {
        color: black;
        font-family: '黑体', '微软雅黑', '宋体', serif;
    }

    & ::v-deep .el-table--border {
        border: 1px solid black;
    }

    & ::v-deep .el-table--border td {
        border: 1px solid black;
    }

    & ::v-deep .el-table--border th {
        border: 1px solid black;
    }

    & .el-form-item--mini.el-form-item {
        margin-bottom: 10px;
    }
}
</style>